export default __webpack_public_path__ + "static/media/mail-open-outline.10e2835e.svg";